import magnifiAPIInstance from "./apiInstance";

export const roleAPIs = {
  getRoleDetails: ({ roleName, payload }) => magnifiAPIInstance.get(`/get-role/${roleName}`, payload),
};
